import { Link } from "react-router-dom";
import TranslationKeys from "../../contexts/I18nContext/translationKeys";
import Translate from "../../components/Translation/Translate";
import useUserInfo from "../../hooks/useUserInfo";
import { routePaths } from "../../routes";

const Dashboard = () => {
  const userInfo = useUserInfo();
  return (
    <div>
      <h1>
        <Translate translationKey={TranslationKeys.HOME_HEADER_TITLE} />
      </h1>
      <div>
        <Link to={routePaths.secondary}>Go to Second Page</Link>
      </div>
      <p>Investor Information: {userInfo.fullName || userInfo.entityName}</p>
    </div>
  );
};
export default Dashboard;
